import { render, staticRenderFns } from "./prize_integral_record.vue?vue&type=template&id=53eabda0&scoped=true&"
import script from "./prize_integral_record.vue?vue&type=script&lang=js&"
export * from "./prize_integral_record.vue?vue&type=script&lang=js&"
import style0 from "./prize_integral_record.vue?vue&type=style&index=0&id=53eabda0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eabda0",
  null
  
)

export default component.exports